import { createFileRoute } from '@tanstack/react-router';

import { CustomPartDetailsTabContent } from '@/areas/parts/PartDetailsPage/components/CustomPartDetailsTabController';
import { canViewCustomPartOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/custom/details/$customPartSpecificationId/offers')({
    staticData: { access: { permissions: canViewCustomPartOffers }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { customPartSpecificationId } = Route.useParams();
    return <CustomPartDetailsTabContent tab={'offers'} specificationId={customPartSpecificationId} />;
}
